<template>
  <div id="service-unavailable">
    <div>
      <h1>We'll Be Right Back!</h1>
      <p>
        This kiosk will attempt to reload in
        <strong v-text="remaining"></strong>.
      </p>
    </div>

    <router-link tag="button" to="/" replace>Reload Now</router-link>
  </div>
</template>

<script>
import { delay } from 'lodash';

let timer;
const MIN = 30;
const MAX = 30;
const countdown = () => Math.ceil(Math.random() * MIN + (MAX - MIN));

export default {
  mounted() {
    this.$nextTick(this.start);
  },

  destroyed() {
    this.$nextTick(() => clearInterval(timer));
  },

  watch: {
    $route() {
      this.start();
    },
  },

  data() {
    return {
      next_attempt: countdown(),
    };
  },

  computed: {
    remaining() {
      const left = Math.max(this.next_attempt, 0);

      return `${left} second${left === 1 ? '' : 's'}`;
    },
  },

  methods: {
    start() {
      clearInterval(timer);

      this.next_attempt = countdown();

      this.decrement();
    },

    decrement() {
      if (--this.next_attempt === 0) {
        this.$router.replace({ path: '/' });

        return;
      }

      timer = delay(this.decrement, 1000);
    },
  },
};
</script>

<style scoped lang="scss">
#service-unavailable {
  background: #eee;
  height: 100%;

  > div {
    background: white;
    padding: 176px 0;
    margin-bottom: 15px;
  }
}

h1,
p {
  line-height: 1;
  margin: 0;
  padding: 0;
  text-align: center;
}

p {
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  color: #333333;
  font-size: 19px;
}

h1 {
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 79px;
  color: #f1eeee;
  margin-bottom: 60px;
  letter-spacing: 1px;
}

button {
  color: white;
  height: 80px;
  line-height: 64px;
  width: 238px;
  font-family: 'Roboto Condensed', sans-serif;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  font-size: 19px;
  background: #929292;
  border-radius: 2px;
  border: none;
  margin: 0 auto;
  display: block;
}
</style>
